export default "__VITE_ASSET__Bh9VaeaE__"